import { FC, ReactElement, memo } from 'react';
import { useNavigate } from 'react-router-dom';

import { AppRoutes } from '@/common/interfaces';
import { FallbackedLayout } from '@/common/layouts';

import { useGetOneByIdSiteGroupsQuery } from '@/modules/SiteGroups';

import { SiteGroupsOverviewView } from './SiteGroupsOverviewView';

interface Props {
  siteGroupId: string;
}

export const SiteGroupsOverviewContainer: FC<Props> = memo(({ siteGroupId }) => {
  const navigate = useNavigate();

  const {
    data: siteGroupData,
    error: siteGroupError,
    isLoading: isSiteGroupLoading,
    isFetching: isSiteGroupFetching,
    isError: isSiteGroupError
  } = useGetOneByIdSiteGroupsQuery(siteGroupId)({
    enabled: !!siteGroupId
  });

  const handleBack = (): void => {
    navigate(AppRoutes.SiteGroups);
  };

  const handleEditSiteGroup = (): void => {
    navigate(AppRoutes.SiteGroupsByIdEdit.replace(':siteGroupId', siteGroupId));
  };

  return (
    <FallbackedLayout
      isLoading={ isSiteGroupLoading }
      isError={ isSiteGroupError }
      error={ siteGroupError }
      data={ siteGroupData }
    >
      { (siteGroup): ReactElement => (
        <SiteGroupsOverviewView
          siteGroup={ siteGroup }
          disableButtons={ isSiteGroupFetching }
          handleBack={ handleBack }
          handleDeletedSiteGroup={ handleBack }
          handleEditSiteGroup={ handleEditSiteGroup }
        />
      ) }
    </FallbackedLayout>
  );
});
